import { render, staticRenderFns } from "./GlassesFrameCreate.vue?vue&type=template&id=7fee26fb&"
import script from "./GlassesFrameCreate.vue?vue&type=script&lang=js&"
export * from "./GlassesFrameCreate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports